import * as React from 'react';
import { liveAnnounce, Level } from 'uitk-react-utils';
import { useLocalization } from '@shared-ui/localization-context';
import { getAriaLiveDate } from './calendar-utils/intl.esm.js';

var AriaLive = function (_a) {
    var customAriaLabels = _a.customAriaLabels, selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd, locale = _a.locale;
    var previousSelectionStartRef = React.useRef(selectionStart);
    var previousSelectionStart = previousSelectionStartRef.current;
    var previousSelectionEndRef = React.useRef(selectionEnd);
    var previousSelectionEnd = previousSelectionEndRef.current;
    var l10n = useLocalization();
    var ariaLiveScenario = React.useMemo(function () {
        var selectionStartHasChanged = selectionStart && previousSelectionStart !== selectionStart;
        if (selectionStartHasChanged) {
            return {
                state: 'NoChange',
                updateSelectionStart: true,
                date: selectionStart
            };
        }
        var selectionEndHasChanged = selectionEnd && previousSelectionEnd !== selectionEnd;
        if (selectionEndHasChanged) {
            return {
                state: 'NoChange',
                updateSelectionEnd: true,
                date: selectionEnd
            };
        }
        var areBothSelectionItemsCleared = previousSelectionStart && previousSelectionEnd && !selectionStart && !selectionEnd;
        if (areBothSelectionItemsCleared) {
            return {
                state: 'BothDatesAreCleared',
                updateSelectionStart: true,
                updateSelectionEnd: true,
                date: selectionStart
            };
        }
        var isStartSelectionCleared = previousSelectionStart && !selectionStart;
        if (isStartSelectionCleared) {
            return {
                state: 'StartDateCleared',
                updateSelectionStart: true,
                date: selectionStart
            };
        }
        var isEndSelectionCleared = previousSelectionEnd && !selectionEnd;
        if (isEndSelectionCleared) {
            return {
                state: 'EndDateCleared',
                updateSelectionEnd: true,
                date: selectionEnd
            };
        }
        return {
            state: 'NoChange'
        };
    }, [previousSelectionStart, selectionStart, previousSelectionEnd, selectionEnd]);
    if (ariaLiveScenario.updateSelectionStart) {
        previousSelectionStartRef.current = selectionStart;
    }
    if (ariaLiveScenario.updateSelectionEnd) {
        previousSelectionEndRef.current = selectionEnd;
    }
    var translationDate = getAriaLiveDate(ariaLiveScenario.date || null, locale);
    var translationKeyMap = {
        StartDateCleared: (customAriaLabels === null || customAriaLabels === void 0 ? void 0 : customAriaLabels.startDateCleared) || l10n.formatText('calendar.startDateCleared.a11yLabel', translationDate),
        EndDateCleared: (customAriaLabels === null || customAriaLabels === void 0 ? void 0 : customAriaLabels.endDateCleared) || l10n.formatText('calendar.endDateCleared.a11yLabel', translationDate),
        BothDatesAreCleared: (customAriaLabels === null || customAriaLabels === void 0 ? void 0 : customAriaLabels.bothDatesCleared) || l10n.formatText('calendar.datesCleared.a11yLabel', translationDate),
        NoChange: ''
    };
    var ariaLiveLabel = translationKeyMap[ariaLiveScenario.state];
    React.useEffect(function () {
        if (ariaLiveLabel) {
            liveAnnounce(ariaLiveLabel, Level.POLITE);
        }
    }, [ariaLiveLabel]);
    return null;
};
var AriaLive$1 = React.memo(AriaLive);

export { AriaLive$1 as default };
